import { render } from "./action.svg.js?vue&type=template&id=6af65d8f&inline!=!../../../../node_modules/vue-loader/dist/index.js??clonedRuleSet-31.use[0]!../../../../scripts/vue-svg-loader.js!./action.svg?vue&type=template&id=6af65d8f&inline"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__